/**
 * @voltxampere/ui — DeleteAnnotationCommand (Sprint 14)
 *
 * Capture the targeted annotation in the constructor so undo can
 * restore it byte-perfect even after the live circuit reference
 * moved on. Mirrors `DeleteCommand`'s snapshot-on-construction
 * discipline (Sprint 13 ADR-0017).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class DeleteAnnotationCommand {
    annotationId;
    snapshot;
    constructor(annotationId, circuit) {
        this.annotationId = annotationId;
        this.snapshot = circuit.annotations.find((a) => a.id === annotationId) ?? null;
    }
    do(circuit) {
        return {
            ...circuit,
            annotations: circuit.annotations.filter((a) => a.id !== this.annotationId),
        };
    }
    undo(circuit) {
        if (!this.snapshot)
            return circuit;
        if (circuit.annotations.some((a) => a.id === this.snapshot?.id))
            return circuit;
        return {
            ...circuit,
            annotations: [...circuit.annotations, this.snapshot],
        };
    }
    describe() {
        return "Annotation silindi";
    }
}
//# sourceMappingURL=delete-annotation.js.map